<template>
  <div id="line-chart">
    <div class="mar-b-30 "
         style="width:100%">
      <ipub-row :gutter="[20,20]">
        <ipub-col :span="2">
          <div class="flex">
            <span class="line-h-40 ipub-p2 fw-bd">Journal</span>
            <ipub-select v-model="params.journalId"
                         placeholder="Select Journal"
                         class="mar-l-12"
                         @change="getSpecial"
                         :options="journalList" />
          </div>
        </ipub-col>
        <ipub-col :span="10">
          <div class="flex ">
            <span class="line-h-40 ipub-p2 fw-bd"
                  style="min-width:110px">Special Issues</span>
            <ipub-select placeholder="Special Issue"
                         :options="specialList"
                         search
                         class="omis"
                         clearable
                         mode="multiple"
                         @search="searchSpecial"
                         @change="changeSource"
                         optionTitle="titleText"
                         v-model="specialIdList" />
            <ipub-button class="search-group-button"
                         @click="handleClear"
                         style="width: 40px;padding: 0;font-size: 28px;margin-left:16px"
                         type="primary"
                         icon="iconClear" />

          </div>
        </ipub-col>
      </ipub-row>
      <ipub-row :gutter="[20,20]">
        <ipub-col :span="2">
          <div class="flex">
            <span class=" ipub-p2 fw-bd">Time Span</span>
            <ipub-select placeholder="Select Journal"
                         class="mar-l-12"
                         v-model="sparams.timeSpan"
                         @change="getTime"
                         :options="['Day','Week','Month']" />
          </div>
        </ipub-col>
        <ipub-col :span="10">
          <div class="flex">
            <span class="line-h-40 ipub-p2 fw-bd">Time Range</span>
            <span class="line-h-40">
              <ipub-label size="common"
                          circle
                          :cover="cho==='30'"
                          @click="changeDate('30',30)"
                          class="mar-l-10 ipub-c-p font-color-d">Last 30 Days</ipub-label>
              <ipub-label size="common"
                          circle
                          :cover="cho==='90'"
                          @click="changeDate('90',90)"
                          class="mar-l-10 ipub-c-p font-color-d">Last 90 Days</ipub-label>
              <ipub-label size="common"
                          circle
                          :cover="cho==='180'"
                          @click="changeDate('180',180)"
                          class="mar-l-10 ipub-c-p font-color-d">Last 180 Days</ipub-label>
              <ipub-label size="common"
                          circle
                          :cover="cho==='365'"
                          @click="changeDate('365',365)"
                          class="mar-l-10 ipub-c-p font-color-d">Last 365 Days</ipub-label>
            </span>

          </div>
        </ipub-col>

      </ipub-row>
    </div>
    <div class="ipub-block">
      <div id="zone-line-chart"
           class="flex"
           style="width:auto;align-items: center;justify-content: center;height:700px">
      </div>
    </div>
  </div>

</template>

<script>
import { statisticSpecial } from '@/api/statistic'
import journal from '@/api/journal'
import special from '@/api/special'

export default {
  data () {
    return {
      params: {
        released: '',
        journalId: '',
      },
      specialIdList: [],
      sparams: {
        specialIdList: [],
        staticDateStart: '',
        staticDateEnd: '',
        timeSpan: 'Day'
      },
      journalList: [],
      specialList: [],

      lineOption: null,
      xx: [],
      cho: '30',
      myChart: '',
      colorType: ['#1E1D40', '#174A87', '#0091FF', '#FA6400'],
    }
  },
  watch: {
    specialIdList: {
      handler (val) {
        if (this.sparams && this.sparams.specialIdList && val) {
          this.getData()
        }
        // this.params.issueId = val
      },
      deep: true
    }
  },
  async mounted () {
    if (this.sparams && this.sparams.specialIdList) {
      this.getData()
    }
    this.changeDate('30', 30)
    await this.getJournalList()

  },
  methods: {
    // 特刊搜索
    async searchSpecial (val) {
      this.specialList = await special.getByTitle({
        journalId: this.params.journalId,
        released: true,
        limit: 100,
        title: val
      })
    },
    // 获取特刊列表
    async getSpecial (journalId) {
      this.specialList = await special.getByTitle({
        journalId: journalId,
        released: true,
        limit: 100,
      })
      this.specialIdList = [this.specialList[0] && this.specialList[0].id]
      this.sparams.specialIdList = this.specialList[0] && this.specialList[0].id
      this.getData()

    },
    // 获取杂志列表
    async getJournalList () {
      this.journalList = await journal.userGet()
      const flag = this.journalList.some(item => {
        if (item.id === localStorage.getItem('journalId')) {
          this.params.journalId = item.id
          return true
        }
      })
      if (!flag) {
        this.params.journalId = this.journalList[0] && this.journalList[0].id
        localStorage.setItem('journalId', this.params.journalId)
      }
      this.getSpecial(this.params.journalId)
    },
    // 获取访问量数据
    async getData () {
      const response = await statisticSpecial.getCharts(this.sparams)
      const xData = response && response.map(item => {
        return item.data && item.data.map(data => {
          return this.$moment(data.staticDate).format('DD/MM/YYYY')
        })

      })

      this.xx = Array.from(new Set(xData.flat()))
      this.xx.sort((a, b) => {
        var aa = a.split('/').reverse().join(),
          bb = b.split('/').reverse().join();
        return aa < bb ? -1 : (aa > bb ? 1 : 0);
      });
      const series = response && response.map((item, index) => {
        return {
          name: item.titleText,
          type: 'line',
          color: this.serviesColor(index),
          smooth: false,
          data: this.serviesData(item),
          showSymbol: true,
          symbol: 'circle',     //设定为实心点
          symbolSize: 10,
        }
      })
      this.optionType(this.xx, series)
    },
    serviesData (item) {
      let arr = []
      item && item.data && item.data.map(data => {
        data.staticDate = this.$moment(data.staticDate).format('DD/MM/YYYY')
        this.xx.map((dtItem, dtIndex) => {
          if (dtItem === data.staticDate) {
            arr[dtIndex] = data.viewNum
          }
        })
        // return data.viewNum
      })

      for (let i = 0; i < arr.length; i++) {
        arr[i] = arr[i] ? arr[i] : 0
      }
      return arr
    },
    getEchart () {
      var echarts = require('echarts')
      if (this.myChart != null && this.myChart != '' && this.myChart != undefined) {
        this.myChart.dispose() // 销毁
      }
      this.myChart = echarts.init(document.getElementById('zone-line-chart'))
      this.myChart.setOption(this.lineOption)
    },
    optionType (x, series) {
      if (x && series) {
        this.lineOption = {
          tooltip: {
            trigger: 'axis',
            enterable: true,
            confine: true, // 限制tootip在容器内
            formatter: function (params) {
              if (params instanceof Array) {
                let str = '';
                str += `${params[0].axisValue}<br/>`;
                params.forEach((m) => {
                  if (m.data) {
                    str += `<span class="chart-tooltip-color" style="display: inline-block; margin-right: 10px; background-color: ${m.color}; width: 10px; height: 10px; border-radius:100%; margin-right: 5px"></span>`;
                    str += `${m.seriesName}：${m.data}`;
                    str += '<br/>';
                  }

                });
                return str;
              }
            },

          },
          title: {
            text: 'Views',
            textStyle: {
              fontSize: 14
            },
          },
          legend: {
            type: 'scroll',
            top: '0',
            left: '60',
            icon: 'circle',
            itemWidth: 14,
            itemHeight: 14,
            itemGap: 16,
          },
          xAxis: {
            name: 'Days',
            data: x,
            type: 'category',
            axisLine: {
              show: true,
              lineStyle: {
                color: '#1E1D40',
                width: 1
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              inside: false,
              rotate: -30
            },
            nameTextStyle: {
              fontSize: 14,
              fontWeight: 600
            }

          },
          yAxis: {
            type: 'value',
            axisLine: {
              show: true,
              lineStyle: {
                color: '#1E1D40',
                width: 1
              }
            },

          },
          dataZoom: {
            left: '4%',
            bottom: 0

          },
          grid: {
            left: '4%',
            right: '4%',
            height: '80%'

          },

          dataset: {
          },
          series: series,

        }
        this.getEchart()
      } else {
        var echarts = require('echarts')
        this.myChart = echarts.dispose()
      }

    },
    // 折线颜色
    serviesColor () {
      this.colorType = ['#111E6C', '#000080', '#1D2951', '#003152', '#0E4D92', '#1034A6', '#0080FF', '#0F52BA', '#008ECC', '#6593F5', '#4C516D', '#7185A5', '#73C2FB', '#57A0D3', '#89CFF0', '#95C8D8', '#4682B4', '#588BAE', '#B0DFE5', '#008081', '#4F97A3', '#81D8D0', '#7EF9FF', '#3FE0D0']
      return this.colorType[Math.floor((Math.random() * this.colorType.length))]
    },
    handleClear () {
      this.sparams = {}
      this.specialIdList = []
      this.cho = ''
      this.getData()
    },
    changeDate (type, time) {
      this.cho = type
      this.sparams.staticDateStart = this.$moment()
        .add(-time, 'd')
        .startOf('day')
      this.sparams.staticDateEnd = this.$moment().endOf('day')
      this.getData()
    },
    changeSource (val) {
      this.sparams.specialIdList = val.join()
      this.getData()
    },
    getTime (val) {
      this.sparams.timeSpan = val
      this.getData()
    },

  }
}
</script>

<style lang="scss" scoped>
@import './main.scss';
#line-chart {
  width: 100%;
}
.ipub-block {
  height: 700px;
}
</style>
